/* eslint-disable no-async-promise-executor */
import { canvasRequest } from '$/api/canvasRquest';
import APP from '$/api/api';
import { GetWorkFlowInfoResult, SaveWorkFlowParams } from './type';

/**
 * 画布列表
 *
 * @export
 * @param {string} from_room_id
 * @return {*}
 */
export async function getWorkFlowList(from_room_id: string) {
  return new Promise<{ list: { room_id: string; }[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        from_room_id,
      },
      method: 'GET',
      url: APP.roboneo.api.workFlowList,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取节点画布数据
 *
 * @export
 * @param {string} room_id
 * @return {*}
 */
export async function getWorkFlowInfo(room_id: string) {
  return new Promise<GetWorkFlowInfoResult>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        room_id,
      },
      method: 'GET',
      url: APP.roboneo.api.workFlowInfo,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 保存节点画布数据
 *
 * @export
 * @param {SaveWorkFlowParams} {
 *   room_id,
 *   data,
 * }
 * @return {*}
 */
export async function saveWorkFlow(data: SaveWorkFlowParams) {
  const response = await canvasRequest.request({
    data,
    method: 'POST',
    url: APP.roboneo.api.saveWorkFlow,
  });
  return response;
}

/**
 * 初始化节点模式
 *
 * @export
 * @param {string} room_id 房间 id
 * @param {string} [code] 分享码等
 * @param {string} [scene] 初始化场景（如资产库带入工作流：`asset_init`）
 * @return {*}
 */
export async function initWorkFlow({
  room_id,
  code,
  scene,
}: { room_id: string; code?: string; scene?: string; }) {
  return new Promise<{ need_submit: boolean; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        code,
        ...(scene ? { scene } : {}),
      },
      method: 'POST',
      url: APP.roboneo.api.initWorkFlow,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 分享节点工作流画布
 *
 * @export
 * @param {string} room_id
 * @param {string} name
 * @return {*}
 */
export async function shareWorkFlow(room_id: string, name: string) {
  return new Promise<{ code: string; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        name,
      },
      method: 'POST',
      url: APP.roboneo.api.shareFlow,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取分享信息
 *
 * @export
 * @param {string} code
 * @return {*}
 */
export async function getWorkFlowShareInfo(code: string) {
  return new Promise<GetWorkFlowInfoResult>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        code,
      },
      method: 'GET',
      url: APP.roboneo.api.share_info,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 设置房间封面
 *
 * @export
 * @param {string} cover
 * @return {*}
 */
export async function setRoomCover(room_id: string, cover: string) {
  const response = await canvasRequest.request({
    data: {
      room_id,
      cover,
    },
    method: 'POST',
    url: APP.roboneo.api.saveCover,
  });
  return response;
}
